import React from "react";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "./Modal";
import Button from "./Button";

export interface PaywallModalProps {
  open: boolean;
  resource: string;
  limit: number;
  onClose: () => void;
}

const PaywallModal: React.FC<PaywallModalProps> = ({ open, resource, limit, onClose }) => {
  return (
    <Modal isOpen={open} onClose={onClose} size="sm">
      <ModalHeader title="Upgrade to Premium" onClose={onClose} />
      <ModalBody>
        <p className="text-zinc-300 text-sm leading-relaxed">
          You&apos;ve reached the free limit of {limit} {resource}. Upgrade to Premium for unlimited
          campaigns, assets, and characters.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
        <Link to="/pricing" onClick={onClose}>
          <Button variant="primary">View plans</Button>
        </Link>
      </ModalFooter>
    </Modal>
  );
};

export default PaywallModal;
